export default "__VITE_ASSET__B$If9mpR__"